import api from "@/api.js";

export default {
  state: {
    config: [],
    configLoading: false
  },
  mutations: {
    setConfig(state, payload) {
      state.config = payload;
    },
    setConfigLoading(state, payload) {
      state.configLoading = payload;
    }
  },
  actions: {
    async loadConfig({ commit, state }) {
      let config;

      config = await api.get("config");

      commit("setConfig", config.data);
    },

    async saveConfig({ commit }, payload) {
      await api.put("config", payload);
    },

    async deleteConfig({ commit }, payload) {
      await api.delete("config/" + payload.id);
    }
  },
  getters: {
    config(state) {
      return state.config;
    },
    configLoading(state) {
      return state.configLoading;
    }
  }
};
